/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * The image registry protocol does not exist
 */
export type ImageRegistryProtocolNotFound = {
	error: ImageRegistryProtocolNotFound.error;
};

export namespace ImageRegistryProtocolNotFound {
	export enum error {
		IMAGE_REGISTRY_PROTOCOL_NOT_FOUND = "IMAGE_REGISTRY_PROTOCOL_NOT_FOUND",
	}
}
